import { useOutletContext } from 'react-router-dom'

import EarningsSection from './EarningsSection/EarningsSection'
import YourNumbersCard from './YourNumbersCard/YourNumbersCard'
import * as Styles from './styles'

const GlobalTab = () => {
  const { periodParams } = useOutletContext()

  return (
    <Styles.Container>
      <EarningsSection periodParams={periodParams} />
      <YourNumbersCard periodParams={periodParams} />
    </Styles.Container>
  )
}

export default GlobalTab
